export enum EEmployeeRole {
	SUPER_ADMIN = 'super_admin',
	ADMIN = 'admin',
	SUPER_DIETITIAN = 'super_dietitian',
	DIETITIAN = 'dietitian',
	SUPER_BOK = 'super_customer_support',
	BOK = 'customer_support',
	SUPER_MARKETING = 'super_marketing',
	MARKETING = 'marketing',
	SUPER_LOGISTICS = 'super_logistics',
	LOGISTICS = 'logistics',
}

const ROLE_LABELS: Record<EEmployeeRole, string> = {
	[EEmployeeRole.SUPER_ADMIN]: 'Super Admin',
	[EEmployeeRole.ADMIN]: 'Admin',
	[EEmployeeRole.SUPER_DIETITIAN]: 'Super Dietetyk',
	[EEmployeeRole.DIETITIAN]: 'Dietetyk',
	[EEmployeeRole.SUPER_BOK]: 'Super BOK',
	[EEmployeeRole.BOK]: 'BOK',
	[EEmployeeRole.SUPER_MARKETING]: 'Super Marketing',
	[EEmployeeRole.MARKETING]: 'Marketing',
	[EEmployeeRole.SUPER_LOGISTICS]: 'Super Logistyka',
	[EEmployeeRole.LOGISTICS]: 'Logistyka',
}

export const convertRoleName = (role: EEmployeeRole | string): string => ROLE_LABELS[role as EEmployeeRole] ?? role

export const employeeRoles: ISelectOption[] = [
	{ value: EEmployeeRole.SUPER_ADMIN, label: ROLE_LABELS[EEmployeeRole.SUPER_ADMIN] },
	{ value: EEmployeeRole.ADMIN, label: ROLE_LABELS[EEmployeeRole.ADMIN] },
	{ value: EEmployeeRole.SUPER_DIETITIAN, label: ROLE_LABELS[EEmployeeRole.SUPER_DIETITIAN] },
	{ value: EEmployeeRole.DIETITIAN, label: ROLE_LABELS[EEmployeeRole.DIETITIAN] },
	{ value: EEmployeeRole.SUPER_BOK, label: ROLE_LABELS[EEmployeeRole.SUPER_BOK] },
	{ value: EEmployeeRole.BOK, label: ROLE_LABELS[EEmployeeRole.BOK] },
	{ value: EEmployeeRole.SUPER_MARKETING, label: ROLE_LABELS[EEmployeeRole.SUPER_MARKETING] },
	{ value: EEmployeeRole.MARKETING, label: ROLE_LABELS[EEmployeeRole.MARKETING] },
	{ value: EEmployeeRole.SUPER_LOGISTICS, label: ROLE_LABELS[EEmployeeRole.SUPER_LOGISTICS] },
	{ value: EEmployeeRole.LOGISTICS, label: ROLE_LABELS[EEmployeeRole.LOGISTICS] },
]

export const mapRoleToSelectOption = (role: EEmployeeRole | string | null | undefined): ISelectOption<string> | null =>
	role ? { value: role, label: convertRoleName(role) } : null

export const findRoleByValue = (value: EEmployeeRole) => employeeRoles.find(role => role.value === value)
